import { render, staticRenderFns } from "./createTaxaEventos.vue?vue&type=template&id=6def914a&scoped=true&"
import script from "./createTaxaEventos.vue?vue&type=script&lang=js&"
export * from "./createTaxaEventos.vue?vue&type=script&lang=js&"
import style0 from "./createTaxaEventos.vue?vue&type=style&index=0&id=6def914a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6def914a",
  null
  
)

export default component.exports